export default __webpack_public_path__ + "static/media/translator-mobile-3.ae6b62ea.png";